import { Injectable } from "@angular/core";
import {BaseApiTemplateService, PagingResponseModel, ApiVisa} from '../../shared';
import {SpendingLimitContainerModel} from '../../../../../../models/aggregates/crm/spending-limit';
import {Core2Config} from '../../shared';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
  export class SpendingLimitService extends BaseApiTemplateService<SpendingLimitContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-rules';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-rules';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-rules';
      this.httpClient = http;
    }
}